module.exports = __webpack_public_path__ + "img/1585188840.b42a823a.jpg";